import Decorate from '@tencent/spaui-decorate';
import { Dialog } from '@tencent/spaui';
import { reportUserBehaviorCgi } from '@/api/operator/cgi/smb/common';
// import agencyMenus from "@/common/menus/index.js"
import { SITE } from '@/constants/config.js';
import { logout } from '@/pages/agency/utils/logout.js';
import globalStore from '@/stores';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';
import _ from 'lodash';
import React, { useCallback, useRef, useEffect, useMemo } from 'react';

const goQQLogin = function () {
  const url = `${SITE.ssoUrl}?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=2`;
  window.location.replace(url);
};

const goWXLogin = function () {
  const url = `https://sso.e.qq.com/login/wx?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=48`;
  window.location.replace(url);
  // const url = `https://sso.e.qq.com/login/hub?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=10&display_login=wx`;
  // logout(url);
};

const goMktAuth = function () {
  const url = `https://e.qq.com/agp/auth/get_mkt_auth_url?redirect_uri=${encodeURIComponent(location.href)}`;
  window.location.replace(url);
};

let dialog = null;
export const handleErrResponse = function (response, errInfo) {
  // 全局的异常弹窗，只允许有一个。
  if (dialog) {
    // 如果存在旧的，立即移除，不播放动画
    dialog.destroy();
    dialog = null;
  }
  dialog = new Decorate(Dialog);

  // 移除Dialog
  function removeDialog() {
    dialog.setProps({
      show: false,
    });
    setTimeout(() => {
      // 执行完动画再销毁
      dialog.destroy();
      dialog = null;
    }, 1000);
  }

  // 接口可能直接返回业务错误对象，也可能是 jQuery Ajax 的 jqXHR；HTTP 500 的响应体通常在 responseJSON 中。
  const responseBody = response?.responseJSON && typeof response.responseJSON === 'object'
    ? response.responseJSON
    : response || {};
  const code = responseBody.code ?? response?.status ?? '';
  const exception = responseBody.exception || {};
  const responseData = responseBody.data && typeof responseBody.data === 'object' ? responseBody.data : {};
  const traceId = responseBody.trace_id || responseBody.traceId || response?.trace_id;
  let defaultMessage = '请求失败，请稍后重试';
  if (response?.status === 500 || code === 500) {
    defaultMessage = '服务异常，请稍后重试，如仍失败请联系管理员';
  } else if (response?.statusText === 'timeout') {
    defaultMessage = '接口请求超时，请稍后重试';
  }
  const message = responseBody.msg
    || responseBody.message
    || responseBody.error
    || responseBody.error_message
    || exception.message
    || responseData.msg
    || responseData.message
    || errInfo
    || defaultMessage;

  const dialogConfig = {
    useNewUI: true,
    show: true,
    title: '错误提示',
    type: 'normal',
    size: 'large',
    backdrop: true,
    enabledBackdropClose: true,
    children: (
      <div className="dialog-err">
        <span>{message}</span>
        {traceId ? <span>{`错误提示码：${traceId}`}</span> : null}
      </div>
    ),
    cancelButton: false,
    onClose: () => {
      dialog.setProps({
        show: false,
      });
    },

  };
  switch (code) {
    case 200000:
    case 409100: // 已实名认证 & 资质未通过
    case 409101: // 未实名认证 & 资质通过
    case 409102: // 未实名认证 & 资质未通过
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goQQLogin,
      });
      break;
    case 200001:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goWXLogin,
      });
      break;
    case 200010:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: goMktAuth,
      });
      break;
    case 301:
      dialog.setProps({
        ...dialogConfig,
        children: (
          <div
            dangerouslySetInnerHTML={{
              __html: `${message}`,
            }}
          ></div>
        ),
        onSubmit: removeDialog,
        onClose: removeDialog,
      });
      break;
    default:
      dialog.setProps({
        ...dialogConfig,
        onSubmit: removeDialog,
        onClose: removeDialog,
      });
  }
};

/**
 * @description 返回当前页面配置
 * @param key {string}
 * @returns {*}
 */
export const getPageConfig = (key = '') => {
  const { account = {} } = globalStore;
  const regx = new RegExp(`^${REACT_APP_PUBLIC_URL}`);
  const href = key || window.location.pathname.replace(regx, '') || '';
  const { siteMap: { routes = {} } = {} } = account;
  const pageConfig = _.find(routes, (v) => v.match && v.match(href)) || {};

  return {
    ...pageConfig,
    pagePurview: pageConfig.pagePurview || {},
    behavior: pageConfig.behavior || {},
  };
};

export const numFormat = (s, round) => {
  if (!isNaN(round)) {
    s = Number(s).toFixed(round);
  } else {
    s = String(s);
  }
  let [l, r] = s.split('.');
  l = l.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  if (r === undefined) {
    return l;
  }
  return [l, r].join('.');
};

export const isEmptyObject = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) return false;
  }
  return true;
};

export const getSpecialField = (list, uid, field) => {
  let fieldVal = '';
  let filterArr = [];

  filterArr = list.filter((item) => {
    return item.agency_uid === uid;
  });
  fieldVal = filterArr[0] && filterArr[0][field];

  return fieldVal;
};

// 获取 url 中的查询参数
export const getQueryParams = (qs) => {
  qs = qs.split('+').join(' ');

  const params = {};
  let tokens;
  const re = /[?&]?([^=]+)=([^&]*)/g;

  while ((tokens = re.exec(qs))) {
    params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
  }

  return params;
};
export const numAdd = (num1, num2) => {
  let baseNum;
  let baseNum1;
  let baseNum2;

  try {
    baseNum1 = num1.toString().split('.')[1].length;
  } catch (e) {
    baseNum1 = 0;
  }
  try {
    baseNum2 = num2.toString().split('.')[1].length;
  } catch (e) {
    baseNum2 = 0;
  }
  baseNum = Math.pow(10, Math.max(baseNum1, baseNum2));
  return (num1 * baseNum + num2 * baseNum) / baseNum;
};

/**
 * @description 上报用户行为
 * @returns {*}
 */
export const reportUserBehavior = ({ href = '', behaviorType, relation_type = '', relation_id = '', relation_name = '', page1 = '', page2 = '', page3 = '', ...otherProps }, options) => {
  const { tree = [], behavior: behaviorMap } = getPageConfig(href);
  const [pageDefault1 = '', pageDefault2 = '', pageDefault3 = ''] = tree;
  const behavior = behaviorMap[behaviorType] || behaviorType || '';
  const params = {
    page1: page1 || pageDefault1,
    page2: page2 || pageDefault2,
    page3: page3 || pageDefault3,
    behavior,
    relation_type,
    relation_id,
    relation_name,
    ...otherProps, // otherProps 支持 custom1 - custom10
  };

  reportUserBehaviorCgi({ data: params }, options);
};

/**
 * 上报组件、页面停留时长，浏览器关闭时会自动使用sendBeacon
 * @param {Object} reportProps {} 上报参数
 * @param {string} relation_name: string;  涉及的数据标识，比如文章标题, 如果是监控 Dialog 的关闭，可以为其起一个名字 填入 relation_name
 * 时间记录字段: val
 */
export const useReportStayTime = (reportProps = {}, relation_name = undefined) => {
  console.assert(!reportProps?.val, 'useReportStayTime 不能占用 val 参数');
  const startTime = useMemo(() => Date.now(), []);

  const report = useCallback((useSendBeacon) => {
    const time = Date.now() - startTime;
    const params = {
      behaviorType: '停留时长',
      relation_name,
      ...reportProps,
      val: Math.floor(time / 1000),
    };
    reportUserBehavior(params, { useSendBeacon });
  }, []);

  useEffect(() => {
    document.body.onbeforeunload = () => {
      report(true);
    };
    return () => {
      report(false);
    };
  }, []);
};

/**
 * 自行控制上报时机的停留时间
 * @param {Function} getProps 获取上报的参数，如 relation_id, relation_type, field3, 返回 null 时不上报，会传入 resetData 的 data
 * @param {string} relation_name 涉及的数据标识，比如文章标题, 如果是监控 Dialog 的关闭，可以为其起一个名字 填入 relation_name
 * @returns {
 *   resetData(data: any),  // 重置数据，数据变更时时调用
 *   report(useSendBeacon: boolean = false), // 上报停留时间
 * }
 */
export function useCustomPeportStayTime(getProps, relation_name = undefined) {
  // 停留时间上报: 开始时间
  const dataRef = useRef({
    data: null,
    startTime: Date.now(),
  });

  const resetData = useCallback((data) => {
    dataRef.current = {
      data,
      startTime: Date.now(),
    };
  }, []);

  // 停留时间上报
  const report = useCallback((useSendBeacon) => {
    let datas = getProps?.(dataRef.current?.data);
    if (!datas) {
      return;
    }
    reportUserBehavior({
      ...datas,
      behaviorType: '停留时长',
      relation_name,
      val: Math.floor((Date.now() - dataRef.current.startTime) / 1000),
    }, { useSendBeacon });
  }, []);

  // 停留时间上报: 组件解绑上报
  useEffect(() => {
    document.body.onbeforeunload = () => {
      report(true);
    };
    return () => {
      report(false);
    };
  }, []);

  return  {
    // 重置数据，数据变更时时调用
    resetData,
    // 停留时间上报
    report,
  };
}


export const isTimeout = (response) => response?.statusText === 'timeout';

export default {
  handleErrResponse,
  isEmptyObject,
  getQueryParams,
  numAdd,
  getSpecialField,
  reportUserBehavior,
  getPageConfig,
  isTimeout,
};
